import { Controller } from "@hotwired/stimulus"
import { BookmarksParser, BookmarksTree } from "netscape-bookmark-parser/web"

// Connects to data-controller="bookmarks-import"
export default class BookmarksImportController extends Controller<HTMLFormElement> {
  static targets = ["input", "counter"]

  declare inputTarget: HTMLInputElement
  declare counterTarget: HTMLDivElement

  connect() {
    this.inputTarget.addEventListener("change", this.#handleFileChange.bind(this))
  }

  #handleFileChange(event: Event) {
    const input = event.target as HTMLInputElement
    if (input.files && input.files.length > 0) {
      const file = input.files[0]
      if (file) {
        const reader = new FileReader()
        reader.onload = (e) => {
          const htmlContent = e.target?.result as string
          const bookmarksTree = BookmarksParser.parse(htmlContent)
          const counts = this.#countTreeElements(bookmarksTree)
          this.counterTarget.textContent = `${counts.bookmarks} bookmarks and ${counts.folders}
          folders will be imported.`
        }
        reader.readAsText(file)
      }
    }
  }

  #countTreeElements(bookmarksTree: BookmarksTree): { bookmarks: number, folders: number } {
    let bookmarks = 0
    let folders = 0

    for (const [, value] of bookmarksTree.entries()) {
      if (typeof value === "string") {
        bookmarks++
      } else if (value instanceof BookmarksTree) {
        folders++
        const childCounts = this.#countTreeElements(value)
        bookmarks += childCounts.bookmarks
        folders += childCounts.folders
      }
    }
    return { bookmarks, folders }
  }
}
